import { Button, Card, CardFooter, Image, Textarea } from "@nextui-org/react";
import { IconLibraryPhoto, IconUserFilled, IconX } from "@tabler/icons-react";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { snackbarToast } from "../../../components/SnackbarToast";
import remarkQueries from "../../../queries/remarkQueries";
import inspectionQueries from "../../../queries/inspectionQueries";
import moment from "moment";
import { BASE_URL } from "../../../apis/api";
import { useApi } from "../../../utils/ApiProvider";
import Empty from "../../../components/Empty";
import Loader from "../../../components/Loader";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { RouteConstant } from "../../../routes/RouteConstant";

const breadCrumbsData = [
    {
        url: RouteConstant.ROOT,
        name: 'Inspections'
    },
    {
        url: RouteConstant.SECTIONPROGRESS,
        name: 'Sections'
    },
    {
        url: RouteConstant.QUESTIONPROGRESS,
        name: 'Questions'
    },
    {
        url: RouteConstant.REMARKSCREEN,
        name: 'Remarks'
    }
]

const RemarkScreen = () => {

    const inputRef = useRef(null);

    const [remarks, setRemarks] = useState([]);
    const [remark, setRemark] = useState("");
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const { apiData, setApiDataAndNotify } = useApi();

    const inspection_id = useSelector((state) => state.inspection.inspection_id);
    const question_id = useSelector((state) => state.inspection.question_id);

    const getData = inspectionQueries.useGetRemarkData(
        (res) => {
            if(res?.success){
                setRemarks(res?.data)
                setIsLoading(false)
            }
        }
    )

    useEffect(() => {
        getData.mutateAsync({inspection_id, question_id})
    }, [apiData]);

    const handleOpenFile = () => {
        if (inputRef.current) {
        inputRef.current.click();
        }
    };

    const handleUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
          const validTypes = ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/avi", "video/mov"];
          if (validTypes.includes(file.type)) {
            setFiles([...files, file]);
          } else {
            snackbarToast("Invalid file type", "error");
          }
        }
    };

    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };

    const handleSubmit = async() => {

        if(remark === ""){
            snackbarToast("Please enter remark", "error")
            return
        }

        let fileData = []
        
        if(files.length > 0){
            const data = await upload()
            fileData = data
        }

        createRemark.mutateAsync({
            inspection_id,
            question_id,
            remark,
            files: fileData
        })

        setRemark("")
        setFiles([])

    }

    const upload = async () => {

        const formData = new FormData();

        files.forEach((file) => {
            formData.append("file", file);
        })

        const uploadedData = await uploadFiles.mutateAsync(formData)

        const fileData = uploadedData?.files?.map((file) => {
            return {
                filename: file?.filename
            };
        })

        return fileData

    }

    const uploadFiles = remarkQueries.useUploadRemarkFiles(
        (res) => {
        }
    )

    const createRemark = remarkQueries.useInsertRemarkData(
        (res) => {
            if(res?.success){
                snackbarToast("Remark added successfully", "success")
                setApiDataAndNotify(new Date())
            }
        }
    )

  return (
    <Fragment>

        <BreadCrumbs  data={breadCrumbsData} />

        <div className="flex justify-center">
            <div className="w-full bg-white p-10 max-[550px]:p-4 rounded-[20px]">
                <Textarea
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                disableAnimation
                disableAutosize
                classNames={{
                base: "w-full",
                inputWrapper: "bg-[#f2f2f2] rounded-[10px] border-none outline-none",
                input: "resize-y min-h-[100px] max-h-[300px] p-2",
                }}
                placeholder="Enter remark"
                variant="bordered"
                />
                <div className="w-full flex justify-between items-center mt-3">
                    <div className="relative">
                    <input
                    onChange={handleUpload}
                    ref={inputRef}
                    type="file"
                    accept="image/*, video/*"
                    className="opacity-0 absolute top-0 left-0 w-full h-full"
                    />
                    <Button
                    onClick={handleOpenFile}
                    isIconOnly
                    className="bg-[#f2f2f2]"
                    >
                        <IconLibraryPhoto size={20} />
                    </Button>
                    </div>
                    <Button onClick={handleSubmit} className="bg-primary text-white">Submit</Button>
                </div>

                {files.length > 0 && (
                    <div className="w-full flex flex-wrap gap-2 mt-4">
                    {files.map((file, index) => {
                        const fileExtension = file?.name.split('.').pop()
                        const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)
                        const isVideo = ['mp4', 'webm', 'ogg'].includes(fileExtension)
                        if(isImage){
                        return(
                            <div
                            key={index}
                            className="relative w-[150px] h-[150px] bg-[#f2f2f2] rounded-[10px] flex justify-center items-center border border-gray-300"
                            >
                                <img
                                src={URL.createObjectURL(file)}
                                alt={`Uploaded file ${index + 1}`}
                                className="w-full h-full object-cover rounded-[10px]"
                                loading="lazy"
                                />
                                <button
                                onClick={() => handleRemoveFile(index)}
                                className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                aria-label={`Remove file ${index + 1}`}
                                >
                                    <IconX size={12} />
                                </button>
                            </div>
                        )
                        }else if(isVideo){
                            return(
                            <div
                            key={index}
                            className="relative w-[150px] h-[150px] bg-[#f2f2f2] rounded-[10px] flex justify-center items-center border border-gray-300"
                            >
                                <video
                                key={index}
                                className="w-full h-full rounded-[10px]"
                                controls
                                >
                                <source src={URL.createObjectURL(file)} type="video/mp4" />
                                Your browser does not support the video tag.
                                </video>
                                <button
                                onClick={() => handleRemoveFile(index)}
                                className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                aria-label={`Remove file ${index + 1}`}
                                >
                                    <IconX size={12} />
                                </button>
                            </div>
                            )
                        }
                    })}
                    </div>
                )}

                {
                    isLoading ?
                    <div className="w-full flex items-center justify-center py-40">
                        <Loader />
                    </div>:
                    <Fragment>
                        {remarks?.length > 0 ?
                            <div className="mt-4">
                                <div className="flex flex-row items-center font-semibold text-[16px]">Remarks
                                    <div className="text-[12px] w-fit px-[10px] py-[2px] bg-purple-400 text-white rounded-[10px] ml-2">{remarks?.length}</div>
                                </div>
                                <div className="mt-4">
                                    {
                                        remarks?.map((data, index) => {
                                            return (
                                                <div key={index} className="w-full border-b border-dashed custom-dash border-gray-300 pb-4 mb-4">
                                                    <div className="w-full flex items-center gap-3">
                                                        <div className="w-fit h-fit bg-primary text-white p-[7px] rounded-full flex items-center">
                                                            <IconUserFilled size={15} />
                                                        </div>
                                                        <span className="font-semibold text-[14px]">{data?.createdBy?.name}</span>
                                                        <span className="font-medium text-[12px] text-[#727272]">{moment(data?.createdAt).format("Do MMM YYYY, h:mm:ss a")}</span>
                                                    </div>
                                                    <div className="ml-10">
                                                        <span className="font-medium text-[14px] mt-2">{data?.remark}</span>
                                                    </div>
                                                    {
                                                        data?.remark_files?.length > 0 &&
                                                        <div className="mt-2 ml-10">
                                                            <div className="w-full flex flex-wrap gap-2">
                                                                {
                                                                    data?.remark_files?.map((file, index) => {
                                                                        const fileExtension = file?.filename.split('.').pop()
                                                                        const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)
                                                                        const isVideo = ['mp4', 'webm', 'ogg'].includes(fileExtension)
                                                                        if(isImage){
                                                                            return(
                                                                                <Card isFooterBlurred className="border-none" radius="lg">
                                                                                    <Image
                                                                                    alt="Woman listing to music"
                                                                                    className="object-cover"
                                                                                    height={150}
                                                                                    width={150}
                                                                                    src={`https://app.requestly.io/delay/500/${BASE_URL}/files/remarks/${file?.filename}`}
                                                                                    />
                                                                                    <CardFooter className="opacity-0 hover:opacity-100 justify-between before:bg-white/10 border-white/20 border-1 overflow-hidden py-1 px-1 absolute before:rounded-xl rounded-large bottom-1 w-[calc(100%_-_8px)] shadow-small ml-1 z-10">
                                                                                        <Button
                                                                                        onClick={() => window.open(`${BASE_URL}/files/remarks/${file?.filename}`, "_blank")}
                                                                                        className="text-tiny text-white bg-black/20 w-full"
                                                                                        color="default"
                                                                                        radius="lg"
                                                                                        size="sm"
                                                                                        variant="flat"
                                                                                        >
                                                                                        Preview
                                                                                        </Button>
                                                                                    </CardFooter>
                                                                                </Card>
                                                                            )
                                                                        }else if(isVideo){
                                                                            return(
                                                                                <div
                                                                                key={index}
                                                                                className="w-[150px] h-[150px]"
                                                                                >
                                                                                    <video
                                                                                    key={index}
                                                                                    className="w-full h-full rounded-[10px]"
                                                                                    controls
                                                                                    >
                                                                                    <source src={`https://app.requestly.io/delay/500/${BASE_URL}/files/remarks/${file?.filename}`} type="video/mp4" />
                                                                                    Your browser does not support the video tag.
                                                                                    </video>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>:
                            <Empty />
                        }
                    </Fragment>
                }

            </div>
        </div>

    </Fragment>
  );
};

export default RemarkScreen;
